import { render, staticRenderFns } from "./ResourceDeleter.vue?vue&type=template&id=54d0460c&"
import script from "./ResourceDeleter.vue?vue&type=script&lang=js&"
export * from "./ResourceDeleter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports